import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SavedSearches = () => {
  const [searches, setSearches] = useState([
    {
      id: 1,
      name: "Senior React Developers",
      criteria: "React, TypeScript, 5+ years",
      location: "Oslo, Norway",
      results: 23,
      newMatches: 3,
      alertEnabled: true,
      lastRun: new Date(Date.now() - 3600000),
      created: new Date(Date.now() - 86400000 * 7)
    },
    {
      id: 2,
      name: "Full Stack Engineers",
      criteria: "Node.js, React, PostgreSQL",
      location: "Remote",
      results: 41,
      newMatches: 7,
      alertEnabled: true,
      lastRun: new Date(Date.now() - 7200000),
      created: new Date(Date.now() - 86400000 * 3)
    },
    {
      id: 3,
      name: "DevOps Specialists",
      criteria: "AWS, Docker, Kubernetes",
      location: "Bergen, Norway",
      results: 15,
      newMatches: 1,
      alertEnabled: false,
      lastRun: new Date(Date.now() - 86400000),
      created: new Date(Date.now() - 86400000 * 14)
    }
  ]);

  const toggleAlert = (searchId) => {
    setSearches(searches?.map(search => 
      search?.id === searchId 
        ? { ...search, alertEnabled: !search?.alertEnabled }
        : search
    ));
  };

  const formatTimeAgo = (timestamp) => {
    const now = new Date();
    const diff = now - timestamp;
    const hours = Math.floor(diff / 3600000);
    const days = Math.floor(diff / 86400000);
    
    if (hours < 24) {
      return `${hours}h ago`;
    } else {
      return `${days}d ago`;
    }
  };

  return (
    <div className="bg-card rounded-xl p-6 shadow-elevation border border-border">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground">Saved Searches</h3>
        <Button variant="outline" size="sm" iconName="Plus" iconPosition="left">
          New Search
        </Button>
      </div>
      <div className="space-y-4">
        {searches?.map((search) => (
          <div key={search?.id} className="p-4 rounded-lg border border-border hover:border-primary/50 transition-colors">
            <div className="flex items-start justify-between mb-3">
              <div className="flex-1">
                <div className="flex items-center space-x-2 mb-1">
                  <h4 className="font-medium text-foreground">{search?.name}</h4>
                  {search?.newMatches > 0 && (
                    <span className="px-2 py-1 text-xs font-medium bg-success/10 text-success rounded-full">
                      {search?.newMatches} new
                    </span>
                  )}
                </div>
                <p className="text-sm text-muted-foreground mb-2">
                  {search?.criteria} • {search?.location}
                </p>
                <div className="flex items-center space-x-4 text-xs text-muted-foreground">
                  <span>{search?.results} results</span>
                  <span>Last run {formatTimeAgo(search?.lastRun)}</span>
                </div>
              </div>
              
              <div className="flex items-center space-x-2">
                <button
                  onClick={() => toggleAlert(search?.id)}
                  className={`p-2 rounded-lg transition-colors ${
                    search?.alertEnabled 
                      ? 'bg-success/10 text-success hover:bg-success/20' :'bg-muted text-muted-foreground hover:bg-muted/80'
                  }`}
                  title={search?.alertEnabled ? 'Disable alerts' : 'Enable alerts'}
                >
                  <Icon name="Bell" size={16} />
                </button>
                
                <button className="p-2 rounded-lg text-muted-foreground hover:text-foreground hover:bg-muted/50 transition-colors">
                  <Icon name="Settings" size={16} />
                </button>
                
                <button className="p-2 rounded-lg text-muted-foreground hover:text-foreground hover:bg-muted/50 transition-colors">
                  <Icon name="Play" size={16} />
                </button>
              </div>
            </div>
            
            {search?.newMatches > 0 && (
              <div className="flex items-center justify-between pt-3 border-t border-border">
                <span className="text-sm text-success font-medium">
                  {search?.newMatches} new candidates found
                </span>
                <Button variant="ghost" size="sm" iconName="ArrowRight" iconPosition="right">
                  View matches
                </Button>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SavedSearches;